import { default as TierContentContainer } from './TierContent.container';
import { default as TierContent } from './TierContent';

export default TierContentContainer(TierContent);
